import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DateRange } from 'app/projects/shared/src/lib/models/date-range.model';

@Component({
    selector: 'app-edit-relevant-executions-date-range-dialog',
    templateUrl: './edit-relevant-executions-date-range-dialog.component.html',
    styleUrls: ['./edit-relevant-executions-date-range-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EditRelevantExecutionsDateRangeDialogComponent implements OnInit {
    @Input()
    relevantExecutionsDateRange: DateRange;

    // Toggle value on program execution level
    relevantExecutionsMode = new FormControl('in_date_range');

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(public dialogRef: MatDialogRef<EditRelevantExecutionsDateRangeDialogComponent>, private _fb: FormBuilder) {}

    ngOnInit(): void {
        this._formGroup = this._fb.group({
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
        });

        if (this.relevantExecutionsDateRange?.startDate || this.relevantExecutionsDateRange?.endDate) {
            this._formGroup.patchValue({
                startDate: this.relevantExecutionsDateRange.startDate,
                endDate: this.relevantExecutionsDateRange.endDate,
            });
        } else {
            this.relevantExecutionsMode.patchValue('manage_manually');
        }
    }

    save(): void {
        this.dialogRef.close({
            relevantExecutionsMode: this.relevantExecutionsMode.value,
            dateRange: {
                startDate: this._formGroup.get('startDate').value,
                endDate: this._formGroup.get('endDate').value,
            },
        });
    }
}
